import { Box, styled } from '@mui/material'

export const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'highlight',
})<{ highlight: boolean }>`
  text-align: right;
  padding: 0 4px;
  font-size: 13px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.custom.gray2};
  height: 100%;
  width: 100%;

  ${({ highlight, theme }) =>
    highlight &&
    `
    color: ${theme.palette.custom.green1};
  `}
`
